import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ItemRow = styled.div<{ isWrap: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  margin-left: 5px;
  margin-bottom: 20px;
  width: 100%;
  ${media.xl`
    margin-left: 10px;
  `}

  ${({ isWrap }) =>
    isWrap &&
    `
    flex-wrap: wrap;
  `}
`;

export const TableDetailsContainer = styled.div`
  gap: 20px;
  ${media.xl`
    padding: 0 10px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  `}
`;

export const OccupancyContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 0;
  padding: 0;
  justify-content: flex-start;
  width: 100%;

  ${media.xl`
    width: auto;
    padding-right: 10px;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  `}
`;

export const OccupancyItem = styled.span`
  padding: 0 5px 0 0;
`;
